<template>
  <div>
    <b-row>
      <b-col cols="12" xl="12">
        <app-filtro
          :fechaDesde="fechaDesdeParam"
          :fechaHasta="fechaHastaParam"
          :numeroPresupuesto="numeroPresupuesto"
          @filtrar="filtrar">
        </app-filtro>  
      </b-col>      
    </b-row>

    <b-row>
      <b-col cols="12">
        <b-card header="Listado de Imputaciones">
          <b-table 
              small 
              responsive="sm"
              :busy="tableBusy"
              class="registro-ordenes" 
              :items="transferenciasPremiosImputaciones" 
              :fields="fields">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>              
            <!-- <template v-slot:cell(fechaRegistro)="data">
              {{ data.item.fechaRegistro | fecha }}
            </template> -->
            <template v-slot:cell(fechaImputacion)="data">
              {{ data.item.fechaImputacion | fecha }}
            </template>
            <template v-slot:cell(importe)="data">
              {{ data.item.importe | moneda }}
            </template>
            <template v-slot:cell(opciones)="data">
              <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                <template slot="button-content">
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item 
                    @click.stop="borrarImputacion(data.item)">
                  <i class="fa fa-remove"></i>Borrar Imputación</b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
          <nav>
            <b-pagination size="sm" 
              :total-rows="totalRegistros" 
              :per-page="registrosPorPagina" 
              v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
          </nav>
        </b-card>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>

          <b-dropdown-item 
              @click.stop="agregar">
            <i class="fa fa-plus"></i>Nueva Imputación</b-dropdown-item>
          <b-dropdown-item 
              @click.stop="exportar">
            <i class="fa fa-file-excel-o"></i>Exportar Listado de Imputaciones</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import Filtro from './transferenciasPremiosImputacionesFiltro.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs';
import moment from 'moment';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'transferenciasPremiosImputaciones/getField',
  mutationType: 'transferenciasPremiosImputaciones/updateField',
});

export default {
  name: 'BancosMovimientosTransferenciasPremiosImputaciones',
  components: {
    appFiltro: Filtro,
    appMensaje: Mensaje,
    appConfirm: Confirm
  },
  mixins: [ 
    msjModal, 
    confirmModal 
  ],
  data () {
    return {
      fields: [
        // { key: 'fechaRegistro' },
        { key: 'fechaImputacion' },
        { 
          key: 'presupuestoNumero',
          label: 'Nro.Presupuesto'
        },
        { key: 'presupuestoInterno' },
        { 
          key: 'ordenTrabajo',
          label: 'Orden de Trabajo'
        },
        {
          key: 'importe',
          class: 'text-right',
        },
        {
          key: 'opciones',
          label: '',
          class:'text-center'
        },
      ],

      tableBusy: false,
    }
  },
  computed: {
    ...mapFields([
      'transferenciasPremiosImputaciones',
      'fechaDesde',
      'fechaHasta',
      'numeroPresupuesto',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas',
    ]),
    fechaDesdeParam() {
      return moment(this.fechaDesde).format('YYYY-MM-DD');
    },
    fechaHastaParam() {
      return moment(this.fechaHasta).format('YYYY-MM-DD');
    }
  },  
  created() {
    this.getItems();
  },
  methods: {
    filtrar(filtro) {
      this.fechaDesde = filtro.fechaDesde;
      this.fechaHasta = filtro.fechaHasta;
      this.numeroPresupuesto = filtro.numeroPresupuesto;
      this.paginaActual = 1;
      
      this.getItems();
    },
    getItems() {
      this.tableBusy = true;
      this.$store.dispatch('transferenciasPremiosImputaciones/getImputacionesTransferencias')
        .then (() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },
    agregar() {
      this.$router.push({ name: 'TransferenciasPremiosImputacionABM' });
    },

    borrarImputacion(item) {
      this.showModalConfirm('¿Desea borrar la imputación seleccionada?', 
            this.borrar.bind(this, item.id), 'Si', null, 'No')
    },
    borrar (transferenciaPremiosImputacionId) {
      this.showSpinner();
      this.$store.dispatch('transferenciasPremiosImputaciones/delete', transferenciaPremiosImputacionId)
        .then(() => this.showModalMsj('La imputación se borró con éxito', this.getItems, this.getItems, 'light'))
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    exportar() {
      this.showSpinner();
      this.$store.dispatch('transferenciasPremiosImputaciones/getImputacionesTransferenciasList')
        .then(() => {
          let exportRpt = Boolean(false); 
          let imputacionesTransferencias = this.$store.getters['transferenciasPremiosImputaciones/transferenciasPremiosImputacionesList'];
          if (imputacionesTransferencias) {
            if (imputacionesTransferencias.length != 0) {
              exportRpt = Boolean(true);
            }
          }
          if (exportRpt) {
            let title= 'Detalle de Imputaciones';
            let fileName = 'imputaciones-transferencias';
            let format = [
              // { titulo: 'Fecha', nombre: 'fechaRegistro', formato: 'fecha' },
              { titulo: 'Fecha Imputacion', nombre: 'fechaImputacion', formato: 'fecha' },
              { titulo: 'Nro.Presupuesto', nombre: 'presupuestoNumero', formato: '' },
              { titulo: 'Presupuesto Interno', nombre: 'presupuestoInterno', formato: '' },
              { titulo: 'Importe', nombre: 'importe', formato: 'importe' },
            ];

            this.exportXLS(title, fileName, imputacionesTransferencias, format);
          } else {
            this.showErrorMsj ('No hay información para exportar');
          }
        })
        .catch( error => this.showErrorMsj (error))
        .finally(() => this.hideSpinner());
    }
  },
  watch: {
    'paginaActual' : function(newVal, oldVal) {
      if ( newVal != 0 && oldVal != 0) {
        this.getItems(); 
      }
    },    
  }    
}
</script>

<style>
</style>
